/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import { BuilderSetupAccountingRoutingModule } from './builder-setup-accounting-routing.module';
import { AccountingDrawRuleListTabComponent } from './components/accounting-draw-rule-list-tab/accounting-draw-rule-list-tab.component';
import { AccountingTabContainerComponent } from './components/accounting-tab-container/accounting-tab-container.component';
import { DrawRuleDetailsStageListComponent } from './components/draw-rule-details/draw-rule-details-stage-list/draw-rule-details-stage-list.component';
import { DrawRuleDetailsTopFormComponent } from './components/draw-rule-details/draw-rule-details-top-form/draw-rule-details-top-form.component';
import { DrawRuleDetailsComponent } from './components/draw-rule-details/draw-rule-details.component';
import { AccountingDrawRuleListTabBusinessService } from './resources/accounting-draw-rule-list-tab-business.service';
import { DrawRuleDetailsBusinessService } from './resources/draw-rule-details-business.service';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),
    BuilderSetupAccountingRoutingModule,
  ],
  providers: [
    AccountingDrawRuleListTabBusinessService,
    DrawRuleDetailsBusinessService,
  ],
  declarations: [
    AccountingTabContainerComponent,
    AccountingDrawRuleListTabComponent,
    DrawRuleDetailsComponent,
    DrawRuleDetailsTopFormComponent,
    DrawRuleDetailsStageListComponent,
  ],
  schemas: [ NO_ERRORS_SCHEMA ],
})
export class BuilderSetupAccountingModule {
}
